<template lang="html">
  <div class="chat_box">
    <div class="chat-header">
      <i class="el-icon-close pull-right close" style="margin:5px;" @click="setChatActive(false)"></i>
      <i class="fa fa-arrow-left fa-lg fa-fw back-icon" aria-hidden="true" @click="$emit('back')"></i>
      <i class="fa fa-user-circle-o fa-2x fa-fw left-icon" :style="contactColor" aria-hidden="true"></i><span :style="contactTextColor">{{chatUser.userName}}</span>
      <br><span class="company-text" :style="contactTextColor">{{chatUser.company||'-'}}</span>
    </div>
    <div class="chat_message_wrapper" ref="msgWrapper">
      <div v-for="(msg,i) in msges" class="message_wrap" :key="msg.timestamp+msg.fromUserId+msg.toUserId">
          <div v-show="fromMe(msg) && (i === 0 || msges[i-1].fromUserId !== msg.fromUserId)" class="name me">
            me
          </div>
          <div class="chat_message me" v-show="fromMe(msg)">
            <div v-html="msg.msg"></div>
            <span class="time">{{getDateString(msg.timestamp)}}
              <i class="fa fa-check read-tick" aria-hidden="true" v-if="msg.readTimestamp && msg.readTimestamp !== ''"></i>
            </span>
          </div>
          <div v-show="!fromMe(msg) && (i === 0 || msges[i-1].toUserId !== msg.toUserId)" class="name other">
            {{chatUser.userName}}
          </div>
          <div class="chat_message other" v-show="!fromMe(msg)">
            <div v-html="msg.msg" class="centralise"></div>
            <span class="time">{{getDateString(msg.timestamp)}}</span>
          </div>
      </div>
      <div v-show="choices.length > 0">
        <button class="choices" type="button" name="button" v-for="c in choices" @click="selectChoice(c)">{{c}}</button>
      </div>
    </div>
    <div class="chat_submit_box">
      <div class="uk-input-group">
        <div class="gurdeep-chat-box">
          <input ref="textInput" type="text" placeholder="Type a message"
            id="submit_message" name="submit_message" class="md-input"
            :value="tmsg"
            autofocus @keyup.enter="sendNewMsg($event.target.value)">
          <span style="padding-left:8px;cursor:pointer;"><i class="fa" :class="speechClass" aria-hidden="true" @click="recordVoice"></i></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';
// import sortBy from 'lodash/sortBy';
import bus from '../util/bus';
// import { adjustTimezone } from '../util/timeLib';

export default {
  data() {
    return {
      recording: false,
      tmsg: '',
    };
  },
  computed: {
    // sortedMsges() {
    //   return sortBy(this.msges, 'timestamp');
    // },
    unreadMsges() {
      return this.msges.filter(m => m.fromUserId !== this.currentUser.userid && m.readTimestamp === '');
    },
    speechClass() {
      if (this.recording) {
        return 'fa-circle-o-notch fa-spin red';
      }
      return this.speechOk ? 'fa-microphone' : 'fa-send-o';
    },
    speechOk() {
      if (window.SpeechRecognition || window.webkitSpeechRecognition || // eslint-disable-line
        window.mozSpeechRecognition || window.msSpeechRecognition) {
        return true;
      }
      return false;
    },
    // choices() {
    //   console.log('choices', this.chatUser);
    //   return this.chatChoices[this.chatUser.userId] || [];
    // },
    ...mapState({
      countries: state => state.minWage.minWageCountries,
      currentUser: state => state.currentUser,
      chatUser: state => state.chatUser,
      mode: state => state.chatMode,
      choices: state => state.chatChoices,
    }),
  },
  methods: {
    fromMe(msg) {
      return msg.fromUserId === this.currentUser.userid;
    },
    selectChoice(choice) {
      this.sendMessage({
        toUserId: this.chatUser.userId,
        msg: choice,
      });
      // this.$emit('sendMsg', choice);
    },
    scrollToEnd() {
      if (!this.$refs.msgWrapper || !this.$refs.msgWrapper.scrollHeight) return;
      this.$refs.msgWrapper.scrollTop = this.$refs.msgWrapper.scrollHeight;
    },
    getDateString(timestamp) {
      const d = new Date(timestamp);
      const options = {
        // weekday: 'short',
        // year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        useGrouping: false,
      };
      return d.toLocaleTimeString('en-sg', options).replace(/,/, '');
    },
    sendNewMsg(msg) {
      if (msg.trim().length <= 0) {
        this.tmsg = '';
        return;
      }
      this.sendMessage({
        toUserId: this.chatUser.userId,
        msg: msg.trim(),
      });
      this.$nextTick(() => {
        this.tmsg = '';
      });
    },
    recordVoice() {
      if (!this.speechOk) {
        this.sendNewMsg(this.$refs.textInput.value);
        return;
      }
      const recognition = new(window.SpeechRecognition || window.webkitSpeechRecognition || // eslint-disable-line
        window.mozSpeechRecognition || window.msSpeechRecognition)();
      recognition.onstart = () => {
        this.recording = true;
      };
      recognition.onresult = (event) => {
        let text = '';
        for (let i = event.resultIndex; i < event.results.length; ++i) { // eslint-disable-line
          text += event.results[i][0].transcript;
        }
        this.tmsg = text;
        recognition.stop();
        // stopRecognition();
      };
      recognition.onend = () => {
        this.sendNewMsg(this.tmsg);
        this.recording = false;
        recognition.stop();
      };
      // var chinese = $('#languageChineseCheck')
      //   .is(':checked');
      // var german = $('#languageGermanCheck')
      //   .is(':checked');
      recognition.start();
    },
    ...mapMutations(['setChatActive']),
    ...mapActions(['sendMessage', 'setReadTimestamp']),
  },
  created() {
    bus.$on('scrollChatToEnd', () => {
      this.$nextTick(() => this.scrollToEnd());
    });
  },
  watch: {
    mode() {
      if (this.mode === 'chat') {
        this.$nextTick(() => {
          this.scrollToEnd();
        });
        this.$refs.textInput.focus();
        if (this.unreadMsges.length > 0) {
          this.setReadTimestamp(this.unreadMsges);
        }
      }
    },
  },
  props: {
    msges: {
      type: Array,
    },
    contactColor: {
      type: Object,
    },
    contactTextColor: {
      type: Object,
    },
  },
};
</script>

<style lang="scss">
.chat-header{
  font-size: 14px;
  position: relative;
  display: block;
  min-height: 20px;
  width: auto;
  padding: 5px 10px;
  color:black;
  background-color: #FFE2C8;
  border-bottom: 1px solid #B68559;
}
.chat-header .left-icon{
  float: left;
  display: block;
  padding-top:3px;
  padding-right:5px;
}
.chat-header .back-icon{
  float: left;
  display: block;
  padding-top:8px;
  cursor: pointer;
}
.chat-header .company-text{
  font-size: 12px;
}
.chat_box .chat_message_wrapper::after {
    clear: both;
}
.chat_box .chat_message_wrapper::after, .chat_box .chat_message_wrapper::before {
    display: table;
}
.chat_box .chat_message_wrapper .chat_user_avatar {
    float: left;
}
.chat_box .chat_message_wrapper {
  font-size: 16px;
  padding: 10px 15px;
  position: absolute;
  left:0;
  right:0;
  top:50px;
  bottom: 45px;
  overflow-x: hidden;
}
.chat_box .chat_message_wrapper .message_wrap {
  clear: both;
  position: relative;
}
.chat_box .chat_message_wrapper .choices{
  width: 100%;
  background: #4db3ff;
  border-color: #4db3ff;
  color: #fff;
  margin-top:4px;
  display: inline-block;
  line-height: 1;
  // white-space: nowrap;
  cursor: pointer;
  border: 1px solid #bfcbd9;
  margin: 3px;
  padding: 10px 15px;
  border-radius: 4px;
}
.chat_box .chat_message_wrapper .chat_message {
    max-width: 66%;
    min-width: 80px;
    border-radius: 4px;
    clear: both;
    color: #212121;
    display: block;
    float: left;
    padding: 8px 16px 20px 8px;
    margin: 5px 0;
    position: relative;
    word-break: keep-all;
}
.chat_box .chat_message_wrapper .chat_message p {
  margin: 0 0 10px;
}
.chat_box .chat_message_wrapper .chat_message .time{
  font-size: 14px;
  color: #999;
  position: absolute;
  display: inline-block;
  bottom: 3px;
  right: 5px;
}
.chat_box .chat_message_wrapper .chat_message.me{
  float: left;
  background: #edeceb none repeat scroll 0 0;
}
.chat_box .chat_message_wrapper .chat_message.other{
    float: right;
    background: #E8FFD4 none repeat scroll 0 0;
}

.chat_box .chat_message_wrapper .chat_message td {
    text-align: center;
    border: 1px solid black;
}
.chat_box .chat_message_wrapper .chat_message th {
    text-align: center;
    border: 1px solid black;
}
.chat_box .chat_message_wrapper .chat_message table{
    border-collapse: collapse;
}

.gurdeep-chat-box i {
    line-height: 1px;
}
.chat_submit_box {
    bottom: 0;
    border-top: 1px solid #DDD;
    box-sizing: border-box;
    left: 0;
    overflow: hidden;
    padding: 10px;
    position: absolute;
    width: 100%;
}
.chat_message_wrapper .message_wrap .name{
  background-color: #FFF;
}
.chat_message_wrapper .message_wrap .name.me{
  float:left;
}
.chat_message_wrapper .message_wrap .name.other{
  float:right;
}
.uk-input-group {
  width: inherit;
    border-collapse: separate;
    display: table;
    position: relative;
}
#submit_message {
    background: transparent none repeat scroll 0 0;
    border: medium none;
    padding: 4px;
    width:90%;
}
.red{
  color: red;
}
.read-tick{
  color:#20A0FF;
  font-size: 10px;
}
.close{
  font-weight: bold;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Chat.vue?2f57d69e